import { Component} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LoaderService } from '../../../shared/services/loader.service';
import { ResetPassRequest } from '../models/reset-pass-request';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-nueva-contrasena',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatError,
  ],
  templateUrl: './nueva-contrasena.component.html',
  styleUrl: './nueva-contrasena.component.scss',
})
export class NuevaContrasenaComponent {
  form: FormGroup;
  hide1 = true;
  hide2 = true;
  email = localStorage.getItem('email') ?? '';
  code = localStorage.getItem('code') ?? '';
  errorInesperado = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private loader: LoaderService,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group(
      {
        nueva: ['', [Validators.required]],
        confirmacion: ['', [Validators.required]],
      },
      { validators: this.contrasenasCoinciden }
    );
  }

  get password(): string {
    return this.form.get('nueva')?.value || '';
  }

  hasMinLength(): boolean {
    return this.password.length >= 8;
  }

  hasNumber(): boolean {
    return /\d/.test(this.password);
  }

  hasUpperCase(): boolean {
    return /[A-Z]/.test(this.password);
  }

  hasLowerCase(): boolean {
    return /[a-z]/.test(this.password);
  }

  hasSpecialChar(): boolean {
    return /[!@#$%^&*(),.?":{}|<>]/.test(this.password);
  }

  // Valida que ambas contraseñas coincidan
  contrasenasCoinciden(group: FormGroup): null | { mismatch: true } {
    const passwordControl = group.get('nueva');
    const confirmControl = group.get('confirmacion');

    if (!passwordControl || !confirmControl) return null;

    const password = passwordControl.value;
    const confirm = confirmControl.value;

    if (password === confirm) {
      confirmControl.setErrors(null);
      return null;
    } else {
      confirmControl.setErrors({ mismatch: true });
      return { mismatch: true };
    }
  }

  get nueva(): FormControl {
    return this.form.get('nueva') as FormControl;
  }

  get confirmacion(): FormControl {
    return this.form.get('confirmacion') as FormControl;
  }

  get mismatch(): boolean {
    return this.form.errors?.['mismatch'] || false;
  }

  isFormValid(): boolean {
    return !!(this.password.trim() && 
           this.confirmacion.value?.trim() &&
           this.password === this.confirmacion.value &&
           this.hasMinLength() &&
           this.hasNumber() &&
           this.hasUpperCase() &&
           this.hasLowerCase() &&
           this.hasSpecialChar());
  }

  onSubmit(): void {
    if (!this.isFormValid()) {
      this.form.markAllAsTouched();
      return;
    }

    const payload: ResetPassRequest = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia',
      },
      petition: {
        email: this.email,
        new_password: this.nueva.value,
        code: this.code,
      },
    };

    this.loader.show();

    this.authService.resetPassword(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        if (res.code === 200) {
          this.snackBar.open('Cambio de contraseña exitoso', 'Cerrar', {
            duration: 4000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: ['bg-green-600', 'text-white'],
          });
          this.router.navigate(['/']);
        } else {
          console.error('Error:', res.message);
        }
      },
      error: (err) => {
        this.loader.hide();
        this.errorInesperado = true;
        console.error('Error:', err);
      },
    });
  }
}